<template>
	<div name="hrms-datepicker" class="box-dpk">
    <input v-model="displayInputDate" @blur="displayCalendar()" 
           class="input-datepicker align-center"
           :name="name + '-display'"
           :class="{ 'input-error' : hasError }" 
           :disabled="disabled"
           :id="name"
           ref="datePickerInput" />

    <input v-model="inputDate" @blur="calendarDate()"
           :name="name"
           :id="name"
           type="hidden"
           ref="datePickerInput" />
	  <date-picker :date="date" :option="option" :disabled="disabled" :limit="limit" @change="changeInputDate(arguments[0])"></date-picker>
	</div>
</template>

<script>
import vueDatepickerForked from 'components/vueDatepickerForked/component'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hrms-datepicker',
  data () {
    return {
      app: this.$root.$children[0],
      inputDate: this.dateOutputConvertFormat(this.dateInputConvertFormat(this.value)),
      date: {
        time: this.dateInputConvertFormat(this.value)
      },
      option: {
        SundayFirst: true,
        type: 'day',
        week: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD'
      },
      displayInputDate: this.dateOutputConvertFormat(this.dateInputConvertFormat(this.value), true)
    }
  },
  mounted () {
    this.option.week = this.dayLists(this.app.nowLang)
    this.option.month = this.monthLists(this.app.nowLang)
  },
  watch: {
    value () {
      this.date.time = this.dateInputConvertFormat(this.value)
    },
    'date.time' () {
      this.displayInputDate = this.dateOutputConvertFormat(this.date.time, true)
      this.inputDate = this.dateOutputConvertFormat(this.date.time)
      this.$emit('input', this.inputDate)
      this.$emit('changeInputDate', this.inputDate)
    },
    'app.nowLang' (newVal) {
      this.option.week = this.dayLists(this.app.nowLang)
      this.option.month = this.monthLists(this.app.nowLang)
    }
  },
  methods: {
    changeInputDate (data) {
      // 02-05-2018
      // 02/05/2018 <= 02-05-2018
      this.$emit('input', this.dateOutputConvertFormat(data))
      this.$emit('changeInputDate', this.dateOutputConvertFormat(data))
    },
    calendarDate () {
      // 02-05-2018 <= 02052018
      this.date.time = this.dateInputConvertFormat(this.inputDate)
      // 02/05/2561 <= 02-05-2018
      this.displayInputDate = this.dateOutputConvertFormat(this.date.time, true)
      // 02/05/2018 <= 02-05-2018
      this.inputDate = this.dateOutputConvertFormat(this.date.time)
      this.$emit('input', this.inputDate)
      this.$emit('changeInputDate', this.inputDate)
    },
    displayCalendar () {
      // 02-05-2018 <= 02052561
      this.date.time = this.dateInputConvertFormat(this.displayInputDate, true)
      // 02/05/2561 <= 02-05-2018
      this.displayInputDate = this.dateOutputConvertFormat(this.date.time, true)
      // 02/05/2018 = 02-05-2018
      this.inputDate = this.dateOutputConvertFormat(this.date.time)
      // 02/05/2018 <= 02/05/2018
      this.$emit('input', this.inputDate)
      this.$emit('changeInputDate', this.inputDate)
    },
    dateInputConvertFormat (dateInput, flgDisplay = false) {
      // ex. dateInput = '31/12/2017' or '31122017'
      let dateInputConverted = ''
      if (dateInput === '' || typeof dateInput === 'undefined') {
        dateInputConverted = ''
      } else {
        let dateInputReplace = dateInput.replace(/\//g, '')
        dateInputConverted = this.removeDisplayYear(dateInputReplace.substring(4, 8), flgDisplay) + '-' + dateInputReplace.substring(2, 4) + '-' + dateInputReplace.substring(0, 2)
      }
      return dateInputConverted
    },
    dateOutputConvertFormat (dateOutput, flgDisplay = false) {
      // ex. dateOutput = '2017-12-31'
      let dateOutputConverted = ''
      if (dateOutput === '') {
        dateOutputConverted = ''
      } else {
        let arrDateOutput = dateOutput.split('-')
        dateOutputConverted = arrDateOutput[2] + '/' + arrDateOutput[1] + '/' + this.addDisplayYear(arrDateOutput[0], flgDisplay)
      }
      return dateOutputConverted
    },
    addDisplayYear (year, flgDisplay) {
      let additionalYear = assetsUtils.getAdditionalYear()
      return (flgDisplay) ? (parseInt(year) + parseInt(additionalYear)) : year
    },
    removeDisplayYear (year, flgDisplay) {
      let additionalYear = assetsUtils.getAdditionalYear()
      return (flgDisplay) ? parseInt(year) - parseInt(additionalYear) : year
    },
    dayLists (lang) {
      let days = {
        en: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        th: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส']
      }
      return typeof days[lang] !== 'undefined' ? days[lang] : days['en']
    },
    monthLists (lang) {
      let months = {
        en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        th: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม']
      }
      return typeof months[lang] !== 'undefined' ? months[lang] : months['en']
    }
  },
  props: {
    value: {
      type: String,
      required: true,
      default: ''
    },
    hasError: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'date'
    },
    limit: {
      type: Array,
      default () {
        return []
      }
    }
  },
  components: {
    'date-picker': vueDatepickerForked
  }
}
</script>

<style src="./style.scss" lang='scss'></style>


// WEBPACK FOOTER //
// component.vue?c97b0510